import React, {useContext, useEffect, useState} from 'react';
import '../MenuTopo/index.css';
import logo from '../../assets/new-logo-w.svg';
import logoMobile from '../../assets/logo-mobile.svg';
import alarm from '../../assets/alarm.svg';
import DommusOnlineFlag from "../DommusOnlineFlag";
import Agenda from "./Agenda";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {Dropdown} from "react-bootstrap";
import { faBars } from '@fortawesome/free-solid-svg-icons';
import '../MenuLateral/index';
import caAPI from "../../services/caAPI";
import { Icon } from '@iconify/react';
import calendarOutlineBadged from '@iconify-icons/clarity/calendar-outline-badged';
import menu from '../../assets/navigation-menu.svg';
import close from '../../assets/close.png';
import NavegadorModulos from '../NavegadorModulos';
import { isDesktop, isTablet } from 'react-device-detect';
import { trackPromise } from 'react-promise-tracker';
import { StatusUsuarioService } from '../../services/StatusUsuarioService';
import { errorToast, successToast } from '../DommusToast'
import { PerfilUsuarioService } from '../../services/PerfilUsuarioService';
import { WebSocketContext } from "../../contexts/WebSocketContext";

export default function MenuTopo({history}) {
    const [statusUsuario, setStatusUsuario] = useState([])
    const [openAgenda, setOpenAgenda] = useState(false);
    const [statusUsuarioAtual, setStatusUsuarioAtual] = useState(null)
    const idUsuario = caAPI.getLocalState('idUsuario')
    const nomeEventoWebsocketUsarioAlterado = `status-usuario-alterado-${idUsuario}`
    const { channel } = useContext(WebSocketContext)

    useEffect(() => {
        channel.unbind(nomeEventoWebsocketUsarioAlterado)
        channel.bind(nomeEventoWebsocketUsarioAlterado, function (data) {
            setStatusUsuarioAtual(data.statusAtualUsuario)
        });
        buscarStatusUsuario()

        return () => channel.unbind(nomeEventoWebsocketUsarioAlterado)
    }, [])

    function buscarStatusUsuario() { 
        StatusUsuarioService.buscarTodosVisiveis()
            .then(response => {
                setStatusUsuario(response.data)
                buscarStatusUsuarioAtual(response.data)
            })
            .catch(error => {
                console.log(error)
                console.log(error?.response)
                errorToast.fire({ text: 'Houve um erro ao buscar os status disponíveis para o usuário.' })
            })
    }

    function buscarStatusUsuarioAtual(statusDisponiveis, idStatusUsuarioAtual=null) {
        if(idStatusUsuarioAtual) {
            setStatusUsuarioAtual(statusDisponiveis.find(status => status.id_status_usuario == idStatusUsuarioAtual))
            
            return
        }
        PerfilUsuarioService.show(idUsuario)
            .then(response => setStatusUsuarioAtual(statusDisponiveis.find(status => status.id_status_usuario == response.data.id_status_usuario)))
            .catch(error => {
                console.log(error)
                console.log(error?.response)
                errorToast.fire({ text: 'Houve um erro ao buscar os status atual do usuário.' })
            })
    }

    function logout(e) {
        e.preventDefault();
        caAPI.logout();
    }

    function abrirMenuMobile() {
      const sidebarMobile = document.getElementById('sidebarMobile');
      const asidebar = document.getElementById('asideMobile');
      const asidebarWrapper = document.getElementById('asideWrapperMobile');
      const barsMenuMobile = document.getElementById('barsMenuMobile');


      if (asidebar.classList == 'sidebar hide') {
        asidebar.classList.remove('hide');
        asidebarWrapper.classList.remove('is-closed');
        sidebarMobile.style.display = 'flex';
        barsMenuMobile.src = close;
      } else {
        asidebar.classList.add('hide');
        asidebarWrapper.classList.add('is-closed');
        sidebarMobile.style.display = 'none';
        barsMenuMobile.src = menu;
      }
    }

    // function openLateral(){
    //   const lateral = !caAPI.getLocalState('dommusMenuMobile');
    //   console.log(lateral);
    //   //localStorage.setItem('dommusMenuMobile', !lateral);

    // }

    function alterarStatusUsuario(statusUsuarioAtual) {
        trackPromise(PerfilUsuarioService.update(idUsuario, { id_status_usuario: statusUsuarioAtual.id_status_usuario }))
            .then(response => {
                buscarStatusUsuarioAtual(statusUsuario)
                successToast.fire({ text: 'Status alterado com sucesso!' })
            }).catch(error => {
                console.log(error)
                console.log(error?.response)
                errorToast.fire({ text: 'Houve um erro ao alterar o status do usuário.' })
            })
    }

    return (
        <>
            <nav className="dommus-menu">
                <div className="logo">
                    <picture>
                        {isDesktop || isTablet ? 
                            <img src={logo} alt="Dommus Conecta"/>
                        :
                            <img src={logoMobile} alt="Dommus Conecta"/>                        
                        }
                    </picture>
                    <div className="modulo-name">
                        <span>|</span>     
                        <NavegadorModulos/>
                    </div>
                </div>
                <div className="right-nav">
                    <div className="info-nav">
                        <div className="online">
                        <Dropdown>
                            <Dropdown.Toggle className="perfil-dropdown">
                                    <DommusOnlineFlag statusUsuarioAtual={statusUsuarioAtual} setStatusUsuarioAtual={setStatusUsuarioAtual}/>
                                    <h1 className="user-name d-none d-md-flex">Olá, {caAPI.getLocalState('nomeUsuario')}</h1>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {/*<Dropdown.Item eventKey="4" onClick={() => {}}>
                                    Perfil
                                </Dropdown.Item>
                                <Dropdown.Divider/>*/}
                                <Dropdown.Header className="border-bottom">Status</Dropdown.Header>
                                {statusUsuario.filter(status => status.id_status_usuario != statusUsuarioAtual?.id_status_usuario)
                                    .map(status => <Dropdown.Item onClick={() => alterarStatusUsuario(status)}>
                                        <span class="status-dot" style={{ backgroundColor: status.cor }}></span> {status.nome}
                                    </Dropdown.Item>)}
                                <Dropdown.Header className="border-bottom">Outros</Dropdown.Header>
                                <Dropdown.Item 
                                    onClick={() => {
                                      history.push('/usuario/gerenciar-assinatura')
                                    }}
                                >
                                  Gerenciar Assinatura
                                </Dropdown.Item>
                                <Dropdown.Item eventKey="4" onClick={(e) => logout(e)}>
                                    Sair
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                        </div>
                        <picture className={"picture-topo"} onClick={() => {
                            setOpenAgenda(statusAtual => {
                                return !statusAtual
                            })
                        }}>
                            <Icon icon={calendarOutlineBadged} width="30" />
                        </picture>
                        <picture className={"picture-topo"}>
                            <img src={alarm} alt="Ícone de sino"/>
                        </picture>
                        <picture className="barsMenuMobile" onClick={() => {
                          abrirMenuMobile()
                        }} id="barsMenuMobile">
                          <FontAwesomeIcon icon={faBars} className="barsMenuMobile"/>
                        </picture>
                    </div>
                </div>
            </nav>
            <Agenda openAgenda={openAgenda} closeAgenda={() => {
                setOpenAgenda(false)
            }}/>
        </>

    )

}
